import { useEffect, useState } from 'react'
import Banner from '../component/Banner'
import { Row, Col } from 'antd';
import axios from 'axios';
import Loader from '../component/Loader';


function About() {

  const [banner, setBanner] = useState(null);
  const [pageContent, setPageContent] = useState(null);

  const getBanner = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}api/get-content/aboutusPageBanner`);
      setBanner(res.data.data[0])
    } catch (err) {
      console.log('Fetching Banner Content', err)
    }
  }

  const getPageContent = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}api/get-content/aboutusPage`);
      setPageContent(res.data.data)
    } catch (err) {
      console.log('Fetching Page Content', err)
    }
  }

  useEffect(() => {
    getBanner();
    getPageContent();
  }, []);

  if (banner === null || pageContent === null) {
    return <Loader />
  }

  return (
    <div>
      <section className="main-about-us">
        <Banner
          Title={banner.title}
          secttile={banner.sub_title}
          dec1={banner.short_details}
          img={`${process.env.REACT_APP_SITE_IMAGES}${banner.image}`}
          dec2={banner.details} />

        <section className="banner bg-black">
          <div className="aboutFirstsec">
            <div className="container mx-auto px-4 pt-20 pb-20">
              <Row align="middle" justify="center" className='pt-20 pb-20' >
                <Col span={12}>
                  <div className="content-sec">
                    <h2 className='w-[580px] font-syne text-4xl font-bold bg-[linear-gradient(90deg,_rgba(67,170,214,1)_60%,_rgba(0,0,0,1)_100%)] bg-clip-text text-transparent'>{pageContent[0].title}</h2>
                    <p className='text-[15px] font-outfit text-white pt-[25px] pt-5 pb-5 text-white w-[480px]'>{pageContent[0].details}</p>
                  </div>
                </Col>
                <Col span={12}>
                  <div className="about-first-sec-img">
                    <img src={`${process.env.REACT_APP_SITE_IMAGES}${pageContent[0].image}`} alt={pageContent[0].title} />
                  </div>
                </Col>
              </Row>
              <Row align="middle" justify="center" gutter={100} className='pt-20 pb-20'>
                <Col span={12}>
                  <div className="about-first-sec-img">
                    <img src={`${process.env.REACT_APP_SITE_IMAGES}${pageContent[1].image}`} alt={pageContent[1].title} />
                  </div>
                </Col>
                <Col span={12}>
                  <div className="content-sec">
                    <h2 className='  w-[580px] font-syne text-4xl font-bold bg-[linear-gradient(90deg,_rgba(67,170,214,1)_60%,_rgba(0,0,0,1)_100%)] bg-clip-text text-transparent'>{pageContent[1].title}</h2>
                    <p className='text-[15px] font-outfit  text-white pt-[25px] pt-5 pb-5 text-white w-[480px]'>{pageContent[1].details}</p>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <div className="text-center pt-10">
                    <h2 className='w-[100%] font-syne text-5xl font-bold bg-[linear-gradient(90deg,_rgba(67,170,214,1)_60%,_rgba(0,0,0,1)_100%)] bg-clip-text text-transparent text-center'>{pageContent[2].title}</h2>
                    <p className='text-[16px] font-outfit  text-white pt-[25px] pt-5 pb-5 text-white w-[90%] m-auto'>{pageContent[2].details}</p>
                    <img src={`${process.env.REACT_APP_SITE_IMAGES}${pageContent[2].image}`} alt={pageContent[2].title} className='d-block m-auto' />
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </section>
      </section>
    </div>
  )
}

export default About
